import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

export const CancelConfirmationModal = ({
  open,
  goBack,
  onConfirmCancel,
}: {
  open: boolean;
  goBack: () => void;
  onConfirmCancel: () => void;
}) => {
  return (
    <Modal
      isOpen={open}
      onClose={goBack}
      titleContent={<div className="font-bold">Unsaved Changes</div>}
      hideCloseButton
    >
      <div className="mb-8">
        <div className="py-1">
          Your changes will be lost if you proceed without saving.
        </div>
        <div className="py-1">Are you sure you want to continue?</div>
      </div>
      <div className="flex items-center justify-end space-x-2">
        <TertiaryButton onClick={goBack}>Back</TertiaryButton>
        <PrimaryButton onClick={onConfirmCancel}>Cancel Changes</PrimaryButton>
      </div>
    </Modal>
  );
};
